import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHomayAgah = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={30}
    height={30}
    fill='none'
    {...props}
  >
    <circle cx={15} cy={15} r={14.5} fill='url(#HomayAgah_svg__a)' stroke='#E0E3EB' />
    <defs>
      <pattern id='HomayAgah_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#HomayAgah_svg__b' transform='scale(.01053)' />
      </pattern>
      <image
        xlinkHref='/images/icons/homay-agah-8390362d.webp'
        id='HomayAgah_svg__b'
        width={95}
        height={95}
      />
    </defs>
  </svg>
);
export default SvgHomayAgah;
